export const SubscriptionSubmitValidation = {
  enableSubmit() {
    this.setSubmitState(false)
  },

  setSubmitState(disabled, message = null) {
    this.submitButtonTargets.forEach((button) => {
      button.disabled = disabled
    })

    if (!this.hasValidationMessageTarget) return

    if (message) {
      this.validationMessageTarget.textContent = message
      this.validationMessageTarget.style.display = 'block'
    } else {
      this.validationMessageTarget.style.display = 'none'
    }
  },
}
